<p>notification-details works!</p>
